import {
  GET_MUKEBS,
  MUKEBS,
  MUKEB_ERROR,
  MUKEB_SUCCESS,
  UPDATE_MUKEB,
  CREATE_MUKEB,
  UPDATE_ACTION_STATUS_MUKEB,
  GET_FEATURES,
  FEATURES,
  ADMIN_ITEMS,
  GET_OLD_MUKEB,
  OLD_MUKEBS,
  OLD_MUKEB_SUCCESS,
  OLD_MUKEB_ERROR,
} from '../actions';

const INIT_STATE = {
  features: [],
  admin_items: [],
  mukebs: [],
  loading: false,
  storeMukebMode: '',
  project: [],
  error: '',
  success: '',
  oldMukeb: null,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case UPDATE_ACTION_STATUS_MUKEB: {
      return { ...state, storeMukebMode: action.payload.status };
    }
    case GET_MUKEBS:
    case GET_OLD_MUKEB:
    case CREATE_MUKEB:
    case UPDATE_MUKEB:
      return {
        ...state,
        loading: true,
        error: '',
        success: '',
      };
    case ADMIN_ITEMS:
      return {
        ...state,
        admin_items: action.payload,
      };
    case FEATURES:
      return {
        ...state,
        features: action.payload,
      };
    case MUKEBS:
      return {
        ...state,
        mukebs: action.payload.mukebs,
        project: action.payload.project,
      };
    case MUKEB_SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        success: action.payload.message,
      };
    case MUKEB_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
        success: '',
      };
    case OLD_MUKEBS:
      return {
        ...state,
        oldMukeb: action.payload.mukeb,
      };
    case OLD_MUKEB_SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        success: action.payload.message,
      };
    case OLD_MUKEB_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
        success: '',
      };
    default:
      return { ...state };
  }
};
